import {
  MockHook,
  LogoContext,
  useEntitlements,
  useFeatureFlags,
} from '@jupiterone/jupiter-web-toolkit';
import React, { useContext, useState } from 'react';
import { FeatureEntitlementName } from '@jupiterone/entitlement-types';
import { useAccounts } from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useAccounts';

export interface CustomLogoLogicProps {
  children: React.ReactNode;
}

const useCustomLogoLogic = ({ children }: CustomLogoLogicProps) => {
  const context = useContext(LogoContext.LogoContext);
  const [imageLoadFailure, setImageLoadFailure] = useState(false);
  const { account } = useAccounts();
  const { hasFeature } = useFeatureFlags();
  const hasAccountLogoFeature = hasFeature('accountLogo');
  const {
    entitlementEnforce,
    loading: entitlementsLoading,
  } = useEntitlements();
  const canViewCompanyLogo =
    !entitlementsLoading &&
    entitlementEnforce(FeatureEntitlementName.CUSTOM_LOGO);
  const companyLogoURI =
    (canViewCompanyLogo && (context?.logoURI || account?.logo)) ?? false;

  const handleImageHasFailedToLoad = () => {
    setImageLoadFailure(true);
  };
  const handleSuccessfulLoadOfImage = () => {
    setImageLoadFailure(false);
  };

  return {
    imageLoadFailure,
    handleImageHasFailedToLoad,
    handleSuccessfulLoadOfImage,
    children,
    hasAccountLogoFeature,
    companyLogoURI,
    accountName: account ? account.name : '',
  };
};

export type CustomLogoComponentProps = ReturnType<typeof useCustomLogoLogic>;
export const MOCK_CUSTOM_LOGO_PROPS: CustomLogoComponentProps = {
  children: [],
  companyLogoURI:
    'https://ca.slack-edge.com/T0129SR43DL-U01J9M1LRMF-5a1fa297132a-512',
  accountName: 'Account Name',
  hasAccountLogoFeature: true,
  imageLoadFailure: false,
  handleImageHasFailedToLoad: MockHook.mockFunction,
  handleSuccessfulLoadOfImage: MockHook.mockFunction,
};
export default MockHook.useMockHook(useCustomLogoLogic, MOCK_CUSTOM_LOGO_PROPS);
